export enum E_Colors {
  Black = '#000000',
  Black19 = '#191919',
  Gray3B = '#3B3B3B',
  Gray3C3C4399 = '#3C3C4399',
  Gray3C3C43 = '#3C3C43',
  Gray47484B = '#47484B',
  Gray66 = '#666666',
  Gray88 = '#888888',
  Gray9C9CA1 = '#9C9CA1',
  GrayA3 = '#A3A3A3',
  GrayB2 = '#B2B2B2',
  GrayB7BEBE = '#B7BEBE',
  GrayCC = '#CCCCCC',
  GrayC7 = '#C7C7C7',
  GrayDD = '#DDDDDD',
  GrayE3 = '#E3E3E3',
  GrayEB = '#EBEBEB',
  GrayF0 = '#F0F0F0',
  GrayF1 = '#F1F1F1',
  GrayF2 = '#F2F2F2',
  GrayF2F2F7 = '#F2F2F7',
  GrayF5F5F7 = '#F5F5F7',
  GrayF4 = '#F4F4F4',
  White = '#FFFFFF',
  EraBlue = '#344F6D',
  EraRed = '#FF3B30',
  Green = '#34C759',

  TextPrimary = '#2E2F33',
  SystemGrey = '#8E8E93',
  SystemGrey3 = '#C7C7CC',
  MainColorAccent = '#9E6DEA',
  Pink = '#DAC6EF',
  PurpleWeak = '#EEE5FB',
  Blue = '#C3CDF0',
  Yellow = '#EDF1A7',
}
